// extracted by mini-css-extract-plugin
module.exports = {"inlineSpinner":"Form-InlineSpinner-module--inline-spinner--3MMrg"};